// Phase E/F — cached snapshot of /inventory-bridge/handoff-state.
//   `state` is null until the first fetch resolves. Components should treat
//   null as "no handoff" (legacy monolith stock UI remains fully active).
export default {
  state: null,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/bridgeHandoff/state.js